<template>
    <Component :is="as">
        {{ relevantDateObject ? $d(relevantDateObject, format || defaultFormat) : '-' }}
    </Component>
</template>

<script setup>
const props = defineProps({
    as: {
        type: String,
        default: "span"
    },
    date: {
        type: String,
        default: null
    },
    dateTime: {
        type: String,
        default: null
    },
    time: {
        type: String,
        default: null
    },
    format: {
        type: String,
        default: null
    },
    hideMidnight: {
        type: Boolean,
        default: false
    }
})

const relevantDateObject = computed(() => {
    // date and time are treated as local time, to avoid timezone issues
    if (props.date) {
        return dayjs(props.date).toDate()
    } else if (props.dateTime) {
        return dayjs.utc(props.dateTime).toDate()
    } else if (props.time) {
        return dayjs(props.time, "HH:mm:ss").toDate()
    }
    return null
})

const defaultFormat = computed(() => {
    if (props.date) {
        return 'dateShort'
    } else if (props.dateTime) {
        if (props.hideMidnight && dayjs(props.dateTime).format('HH:mm:ss') === '00:00:00') {
            return 'dateShort'
        }
        return 'dateTimeShort'
    } else if (props.time) {
        return 'timeShort'
    }
    return 'dateShort'
})

const dayjs = useDayjs()

</script>
